// extracted by mini-css-extract-plugin
export var wrap = "logo-module--wrap--3jHDo";
export var svg = "logo-module--svg--1ODUm";